import {css} from 'lit-element'; export default css`.auth-dialog.-loading{opacity:.2;cursor:wait}.auth-dialog.-loading>*{pointer-events:none}.auth-dialog__error{color:var(--color-red);line-height:1.2}`;
    